var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.summaryText)?_c('div',{staticClass:"tw:typography-small tw:text-secondary"},[_vm._v(" "+_vm._s(_setup.summaryText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }